import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const flags = {
  'Indonesia': '🇮🇩', 'Japan': '🇯🇵', 'Korea': '🇰🇷', 'Thailand': '🇹🇭',
  'China': '🇨🇳', 'Vietnam': '🇻🇳', 'Philippines': '🇵🇭', 'Malaysia': '🇲🇾',
  'India': '🇮🇳', 'Western': '🌍'
};

const CategoryOverlay = ({ isOpen, onClose, onSelect }) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (isOpen) {
      axios.get(`${BACKEND_URL}/api/categories`).then(r => {
        setCategories(r.data || []);
      }).catch(() => {});
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="cat-overlay" onClick={onClose}>
      <div className="cat-overlay-panel" onClick={(e) => e.stopPropagation()}>
        <div className="cat-overlay-header">
          <h3 className="cat-overlay-title">Pilih Kategori</h3>
          <button className="cat-overlay-close" onClick={onClose}><X size={20} /></button>
        </div>
        <div className="cat-overlay-grid">
          {categories.map((cat) => (
            <button
              key={cat.id}
              className="cat-overlay-item"
              onClick={() => { onSelect(cat.name); onClose(); }}
            >
              <span className="cat-overlay-flag">{flags[cat.name] || '📁'}</span>
              <span>{cat.name}</span>
              {cat.count > 0 && <span style={{ fontSize: 10, color: '#888', marginLeft: 'auto' }}>{cat.count}</span>}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryOverlay;
